import Vue from 'vue';

Vue.component('stock-return-index', () =>
    import(/* webpackChunkName: 'stock-return-index' */ './stock-return-index.vue'),
);
